import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

const config = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID
};

firebase.initializeApp(config);

const db = firebase.database();
const auth = firebase.auth();
const currentUser = auth.currentUser;

const AdminNotesRef = db.ref("AdminNotes");
const AdminUsersRef = db.ref("AdminUsers");
const AdminParamsApprovedRef = db.ref("AdminParamsApproved");
const AdminParamsToReviewRef = db.ref("AdminParamsToReview");
const AdminParticipantDetailsRef = db.ref("AdminParticipantDetails");
const AdminSettingsRef = db.ref("AdminSettings");
const BgDataRef = db.ref("BgData");
const GraphDataWeeklyRef = db.ref("GraphDataWeekly");
const GraphDataDailyRef = db.ref("GraphDataDaily");
const DevicesRef = db.ref("Devices");
const StudiesRef = db.ref("Studies");
const ParametersRef = db.ref("Parameters");
const BolusLogsRef = db.ref("BolusLogs");
const BasalLogsRef = db.ref("BasalLogs");
const FeedbackRef = db.ref("Feedback");
const LatestEntriesLogsRef = db.ref("LatestEntriesLogs");
const LogsRef = db.ref("Logs");
const GroupsRef = db.ref("Groups");
const SurveyClicksRef = db.ref("SurveyClicks");
const SurveysRef = db.ref("Surveys");
const MoodFeedbackRef = db.ref("MoodFeedback");
const StatsRef = db.ref("Stats");
const ResetRequestsRef = db.ref("ResetRequests");
const NotificationsLogsRef = db.ref("NotificationsLogs");
const NoteLogsRef = db.ref("NoteLogs");

export {
  db,
  auth,
  currentUser,
  AdminNotesRef,
  AdminUsersRef,
  AdminParamsApprovedRef,
  AdminParamsToReviewRef,
  AdminParticipantDetailsRef,
  AdminSettingsRef,
  BgDataRef,
  GraphDataWeeklyRef,
  GraphDataDailyRef,
  DevicesRef,
  StudiesRef,
  ParametersRef,
  BolusLogsRef,
  BasalLogsRef,
  FeedbackRef,
  LatestEntriesLogsRef,
  LogsRef,
  GroupsRef,
  SurveyClicksRef,
  SurveysRef,
  MoodFeedbackRef,
  StatsRef,
  ResetRequestsRef,
  NotificationsLogsRef,
  NoteLogsRef
};
